import { ManagersModuleBase } from "Managers/ManagersModuleBase";
import { WeeklyRotaDetailsViewModel } from "../WeeklyRotaDetailViewModel";
import { APIManager } from "./APIManager";
import { CommandsManager } from "./CommandsManager";
import { DomainManager } from "./DomainManager";
import { MobXManager } from "./MobXManager";

export class ManagersModule extends ManagersModuleBase<WeeklyRotaDetailsViewModel> {
    public api!: APIManager;
    public commands!: CommandsManager;
    public domain!: DomainManager;
    public mobx!: MobXManager;

    constructor(viewModel: WeeklyRotaDetailsViewModel) {
        super(viewModel);
        this.createManagers();
    }

    protected createManagers(): void {
        // MobX manager first — provides observable state to other managers
        this.mobx = new MobXManager();
        this.api = new APIManager(this.viewModel);
        this.domain = new DomainManager();
        this.commands = new CommandsManager(this.viewModel);
    }
}
